/**
 * Юридические документы: адреса статических страниц и редакция оферты.
 *
 * Адреса живут здесь, а не только во фронтовом `shared/config/legal.ts`, потому что ссылки на
 * документы собирает ещё и бот (команда `/terms`), а бэкенд фронтового кода не видит. Три копии
 * одной строки — это три места, где она разъедется при смене адреса.
 *
 * ---
 *
 * Редакция пользовательского соглашения (оферты).
 *
 * Живёт в контрактах, потому что одно и то же значение нужно трём сторонам сразу:
 *
 *   • статической странице `apps/web/public/terms/<версия>/index.html` — она лежит по адресу
 *     своей редакции;
 *   • бэкенду — он пишет принятую редакцию в `terms_acceptances` (запись делает СЕРВЕР, клиент
 *     версию не присылает: иначе выкаченный старый клиент фиксировал бы акцепт документа,
 *     которого человек не видел);
 *   • фронту — он сравнивает принятую редакцию с действующей и показывает шторку акцепта тем,
 *     кто действующую ещё не принимал.
 *
 * Разъехаться этим трём нельзя: запись «принял v1» обязана указывать на текст, который можно
 * открыть и прочитать. Поэтому значение одно и оно здесь.
 *
 * КАК ВЫПУСКАТЬ НОВУЮ РЕДАКЦИЮ (порядок важен, он же описан в docs/legal.md §13.5):
 *   1. Скопировать `apps/web/public/terms/v1/` в `apps/web/public/terms/v2/`, править копию.
 *      Старая редакция остаётся лежать по своему адресу навсегда — она была договором
 *      с теми, кто принял её.
 *   2. Переключить `location = /terms` в `apps/web/nginx.conf` на новый каталог и добавить
 *      точный `location = /terms/v2`.
 *   3. Поднять `TERMS_VERSION` и `TERMS_VERSION_DATE` здесь.
 *   4. Ничего больше: те, кто принимал прошлую редакцию, увидят шторку акцепта сами —
 *      сравнение идёт с этой константой.
 */

/** Политика обработки персональных данных. Точный `location` в apps/web/nginx.conf. */
export const PRIVACY_PATH = '/privacy'

/** Действующая редакция оферты. Совпадает с каталогом в `apps/web/public/terms/`. */
export const TERMS_VERSION = 'v1'

/**
 * Дата редакции — та, что напечатана в шапке документа. Отдельно от номера, потому что номер
 * машинный (в него смотрит код), а дата человеческая (её называют в переписке и в претензии).
 */
export const TERMS_VERSION_DATE = '2026-08-18'

/** Адрес действующей редакции. Точный `location` в apps/web/nginx.conf. */
export const TERMS_PATH = '/terms'

/**
 * Постоянный адрес конкретной редакции. По нему открывается ровно тот текст, который человек
 * принял, — сколько бы редакций ни вышло после.
 */
export function termsVersionPath(version: string): string {
  return `${TERMS_PATH}/${version}`
}
